import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, TransitionGroup as _TransitionGroup, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-aebf6a80"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "layout-navbars-breadcrumb-span"
}
const _hoisted_2 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_i_expand = _resolveComponent("i-expand")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_i_fold = _resolveComponent("i-fold")!
  const _component_el_breadcrumb_item = _resolveComponent("el-breadcrumb-item")!
  const _component_el_breadcrumb = _resolveComponent("el-breadcrumb")!

  return (_openBlock(), _createElementBlock("div", {
    class: "layout-navbars-breadcrumb",
    style: _normalizeStyle({ display: $setup.isShowBreadcrumb })
  }, [
    ($setup.getThemeConfig.isCollapse)
      ? (_openBlock(), _createBlock(_component_el_icon, {
          key: 0,
          class: "layout-navbars-breadcrumb-icon",
          onClick: $setup.onThemeConfigChange
        }, {
          default: _withCtx(() => [
            _createVNode(_component_i_expand)
          ]),
          _: 1
        }, 8, ["onClick"]))
      : _createCommentVNode("", true),
    (!$setup.getThemeConfig.isCollapse)
      ? (_openBlock(), _createBlock(_component_el_icon, {
          key: 1,
          class: "layout-navbars-breadcrumb-icon",
          onClick: $setup.onThemeConfigChange
        }, {
          default: _withCtx(() => [
            _createVNode(_component_i_fold)
          ]),
          _: 1
        }, 8, ["onClick"]))
      : _createCommentVNode("", true),
    _createVNode(_component_el_breadcrumb, { class: "layout-navbars-breadcrumb-hide" }, {
      default: _withCtx(() => [
        _createVNode(_TransitionGroup, {
          name: "breadcrumb",
          mode: "out-in"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.breadcrumbList, (v, k) => {
              return (_openBlock(), _createBlock(_component_el_breadcrumb_item, {
                key: v.meta.title
              }, {
                default: _withCtx(() => [
                  (k === _ctx.breadcrumbList.length - 1)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
                        ($setup.getThemeConfig.isBreadcrumbIcon)
                          ? (_openBlock(), _createElementBlock("i", {
                              key: 0,
                              class: _normalizeClass([v.meta.icon, "layout-navbars-breadcrumb-iconfont"])
                            }, null, 2))
                          : _createCommentVNode("", true),
                        _createTextVNode(_toDisplayString(_ctx.$t(v.meta.title)), 1)
                      ]))
                    : (_openBlock(), _createElementBlock("a", {
                        key: 1,
                        onClick: _withModifiers(($event: any) => ($setup.onBreadcrumbClick(v)), ["prevent"])
                      }, [
                        ($setup.getThemeConfig.isBreadcrumbIcon)
                          ? (_openBlock(), _createElementBlock("i", {
                              key: 0,
                              class: _normalizeClass([v.meta.icon, "layout-navbars-breadcrumb-iconfont"])
                            }, null, 2))
                          : _createCommentVNode("", true),
                        _createTextVNode(_toDisplayString(_ctx.$t(v.meta.title)), 1)
                      ], 8, _hoisted_2))
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 4))
}